import { estimate1RM } from '../vendor/opengym/estimate1rm.js';
export function parseDecimalMinor(value) {
  const text = String(value).trim().replace(',', '.');
  if (!/^\d{1,4}(\.\d{1,2})?$/.test(text)) throw new Error('Yük en fazla iki ondalıklı pozitif bir sayı olmalı.');
  const [whole, decimal = ''] = text.split('.');
  const result = Number(whole) * 100 + Number(decimal.padEnd(2, '0'));
  if (!Number.isSafeInteger(result) || result > 200000) throw new Error('Yük alanı kayıt sınırını aşıyor.');
  return result;
}
export function parseReps(value) {
  if (!/^\d{1,3}$/.test(String(value)) || Number(value) > 100) throw new Error('Tekrar 0–100 arasında bir tam sayı olmalı.');
  return Number(value);
}
export const setKey = (exerciseId, ordinal) => JSON.stringify([exerciseId, ordinal]);
export function overlayWorkout(workout, rows) {
  if (!workout) return null;
  const next = structuredClone(workout);
  const byKey = new Map(next.sets.map(s => [setKey(s.exercise_id, s.ordinal), s]));
  for (const row of rows.filter(x => x.workoutId === next.id).sort((a,b) => a.sequence - b.sequence)) {
    const o = row.op;
    if (o.type === 'finish') continue;
    const k = setKey(o.exerciseId, o.ordinal);
    if (o.type === 'set.delete') { byKey.delete(k); next.tombstones = [...(next.tombstones||[]).filter(s=>setKey(s.exercise_id,s.ordinal)!==k), {exercise_id:o.exerciseId,equipment_id:o.equipmentId,ordinal:o.ordinal,revision:o.setRevision+1}]; continue; }
    byKey.set(k, { ...byKey.get(k), exercise_id: o.exerciseId, equipment_id: o.equipmentId, ordinal: o.ordinal,
      reps: o.reps, weight_minor: o.weightMinor, revision: o.setRevision + 1, local: true, localStatus: row.status });
  }
  next.sets = Array.from(byKey.values()); return next;
}
export function elapsedSeconds(startedAt, endedAt = null, now = Date.now()) {
  const start = Date.parse(startedAt), end = endedAt ? Date.parse(endedAt) : now;
  return Number.isFinite(start) && Number.isFinite(end) ? Math.max(0, Math.floor((end-start)/1000)) : 0;
}
export function remainingSeconds(deadline, now = Date.now()) { return Math.max(0, Math.ceil((deadline - now) / 1000)); }
export function clock(seconds) { const n = Math.max(0, Math.floor(seconds)); return `${Math.floor(n/60)}:${String(n%60).padStart(2, '0')}`; }
/** Estimate grouping is always physical equipment + exercise, never exercise alone. */
export function summarizeSets(sets) {
  const groups = new Map(); let volumeMinor = 0;
  for (const s of sets) {
    if (!Number.isFinite(s.weight_minor) || !Number.isInteger(s.reps) || s.deleted) continue;
    volumeMinor += s.weight_minor * s.reps;
    const k = JSON.stringify([s.exercise_id, s.equipment_id]), est = estimate1RM(s.weight_minor/100, s.reps);
    const previous = groups.get(k);
    if (est !== null && (!previous || est > previous.estimate)) groups.set(k, { exerciseId: s.exercise_id, equipmentId: s.equipment_id, estimate: est, reps: s.reps, weightMinor: s.weight_minor });
  }
  return { count: sets.filter(s => !s.deleted).length, volumeMinor, estimates: [...groups.values()] };
}
export function filterCatalog(catalog, query, equipment = '', onlyIds = null) {
  const normalize = x => String(x ?? '').toLocaleLowerCase('tr').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const words = normalize(query).split(/\s+/).filter(Boolean);
  return catalog.filter(e => (!equipment || e.equipment === equipment) && (!onlyIds || onlyIds.has(e.id)) && words.every(w => normalize(`${e.nameTr || ''} ${e.name} ${e.bodyPart || ''} ${e.target || ''}`).includes(w)));
}
